import {mapMutations} from 'vuex'
export const wechatPay = {
  methods: {
    ...mapMutations({
      setLoading: "setLoadingShow"
    }),
    wechatPay(params,callBack) {
      console.log(params);
      this.setLoading({
        show: true,
        text: "支付准备中"
      });
      this.$api
        .payment_v1_order_wechat_jsapi_order_create_post({
          data: params
        })
        .then(e => {
          this.setLoading({
            show: false
          });
          if (!e) return;
          this.prepayMap = {
            appId: e.prepayMap.appId,
            nonceStr: e.prepayMap.nonceStr,
            package: e.prepayMap.package,
            signType: e.prepayMap.signType,
            timeStamp: e.prepayMap.timeStamp,
            paySign: e.prepayMap.sign
          };
          let _this = this;
          if (typeof WeixinJSBridge == "undefined") {
            if (document.addEventListener) {
              document.addEventListener(
                "WeixinJSBridgeReady",
                _this.onBridgeReady(_this.prepayMap,callBack),
                false
              );
            } else if (document.attachEvent) {
              document.attachEvent(
                "WeixinJSBridgeReady",
                _this.onBridgeReady(_this.prepayMap,callBack)
              );
              document.attachEvent(
                "onWeixinJSBridgeReady",
                _this.onBridgeReady(_this.prepayMap,callBack)
              );
            }
          } else {
            _this.onBridgeReady(_this.prepayMap,callBack);
          }
        });
    },
    onBridgeReady(prepayMap,callBack) {
      let _this = this;
      WeixinJSBridge.invoke("getBrandWCPayRequest", {
        ...prepayMap
      }, function (res) {
        if( typeof(callBack) == "function" ){
          callBack(res);
          return;
        }
        if (res.err_msg == "get_brand_wcpay_request:ok") {
          _this.setLoading({
            show: true,
            txt: "更新数据中"
          });
          setTimeout(() => {
            _this.setLoading({
              show: false
            });
            _this.$store.commit("setToastShow", {
              show: true,
              content: {
                txt: "支付成功，如还未显示，请刷新页面",
                type: "txt"
              }
            });
            _this.$router.go(-1);
          }, 500);
        } else {
          _this.setLoading({
            show: false
          });
          _this.$store.commit("setToastShow", {
            show: true,
            content: {
              txt: "支付失败，请重试!",
              type: "txt"
            }
          });
        }
      });
    }
  },
}